<cm-add-item-dialog title="Create New Tag" [confirmDisabled]="!$isFormValid()" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <div cm-dialog-content class="cm-add-tag-form">
        @if ($can().update.tag()) {
            <cm-organization-select [usedInAddEntityContext]="true" [updateOrganization]="updateOrganization" [showLabel]="false"> </cm-organization-select>
        }

        <cm-input-container>
            <ng-container cm-inline-label>Name:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="$data().name" (valueChange)="$data.set({...$data(), name: $event})"></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Tag Type:</ng-container>
            <ng-container cm-input>
                <mat-select placeholder="Tag Type" [ngModel]="$data().type" (ngModelChange)="updateDataType($event)" name="tagType">
                    @for (tagType of $tagTypes(); track tagType.state) {
                        <mat-option [value]="tagType.state">{{ tagType.label }}</mat-option>
                    }
                </mat-select>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Description:</ng-container>
            <ng-container cm-input>
                <cm-native-input-text-area
                    placeholder="Description (optional)"
                    [initialValue]="$data().description || ''"
                    (valueChange)="$data.set({...$data(), description: $event})"
                >
                </cm-native-input-text-area>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Color:</ng-container>
            <ng-container cm-input>
                <cm-color-input placeholder="Color (optional)" [hexValue]="$data().color" (hexValueChange)="updateDataColor($event)"> </cm-color-input>
            </ng-container>
        </cm-input-container>
    </div>
</cm-add-item-dialog>
